import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import users from './modules/users';
import venues from './modules/venues';
import devices from './modules/devices';
import groups from './modules/groups';
import assets from './modules/assets';
import assets_folders from './modules/assets_folders';
import playlists from './modules/playlists';
import schedules from './modules/schedules';
import license from './modules/license';
import promotions from './modules/promotions';
import config from './modules/config';
import m5ui from './modules/m5ui';

import { USER_ROLES, USER_MENUS } from '@/constants';

export default new Vuex.Store({
  state: {
    fromUrl: null,
    version: null,
    isFullVersion: false,
    orientations: [
      { name: 'Portrait', value: 'portrait' },
      { name: 'Landscape', value: 'landscape' }
    ],
    angles: [0, 90, 180, 270],
    sourceTypes: ['App', 'IPTV', 'Playlist', 'Website'],
    settingsTab: true
  },
  mutations: {
    SET_FROM_URL(state, url) {
      state.fromUrl = url;
    },
    SET_VERSION(state, payload) {
      state.version = payload.version;
      state.isFullVersion = payload.isFullVersion;
    },
    SET_SETTINGS_TAB(state, payload) {
      state.settingsTab = payload;
    }
  },
  getters: {
    GET_MENU_LIST: (state, _getters, rootState) => {
      const basePages = ['Devices', 'Groups', 'Assets', 'Playlists', 'Schedules'];
      const specialPages = ['Users', 'Venues', 'Settings', 'User Profile', 'Actions'];

      const { rootUser, role, menus = [] } = rootState.users.user || {};

      const additionalPages = [
        ...new Set(menus.filter(item => item && item !== USER_MENUS.BANNER_CONFIG))
      ];

      let finalPages = [];

      if (rootUser || role === USER_ROLES.ADMINISTRATOR) {
        finalPages = [...basePages, ...specialPages];
      } else if (role === USER_ROLES.REGULAR_USER) {
        finalPages = ['User Profile'];
      } else if (role === USER_ROLES.NONPUBLISH_USER) {
        const { pages: npPages = [] } = rootState.users.npUserSettings || {};
        finalPages = npPages;
      } else {
        finalPages = [...basePages, ...specialPages];
      }

      const allPages = [...new Set([...finalPages, ...additionalPages])];

      if (!state.settingsTab) {
        const idx = allPages.indexOf('Settings');
        if (idx > -1) allPages.splice(idx, 1);
      }

      return allPages;
    },
    GET_FROM_URL: state => state.fromUrl,
    GET_CMS_VERSION: state => state.version,
    GET_IS_FULL_VERSION: state => state.isFullVersion,
    GET_ORIENTATIONS: state => state.orientations,
    GET_ANGLES: state => state.angles,
    GET_SOURCE_TYPES: state => state.sourceTypes
  },
  modules: {
    users,
    venues,
    devices,
    groups,
    assets,
    assets_folders,
    playlists,
    schedules,
    license,
    promotions,
    config,
    m5ui
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js